import React from "react";
import "./Terrasse.css";

const photos = [
  { src: "/images/Terrasse/terrasse-3.jpg", alt: "Tables dressées sous les parasols de la terrasse" },
  { src: "/images/Terrasse/terrasse-1.jpg", alt: "Vue sur la terrasse à travers un olivier" },
  { src: "/images/Terrasse/terrasse-2.jpg", alt: "Mise en place et verres à vin en terrasse" },
  { src: "/images/Terrasse/terrasse-4.jpg", alt: "Terrasse ombragée entourée de verdure" },
];

function Terrasse() {
  return (
    <main className="terrasse-page" aria-labelledby="terrasse-title">

      {/* ── En-tête ─────────────────────────────────────────── */}
      <header className="terrasse-header">
        <span className="terrasse-eyebrow">Extérieur</span>
        <h1 id="terrasse-title">
          Notre <em>terrasse</em>
        </h1>
        <div className="terrasse-header-divider" />
        <p className="lead">
          À seulement 5 minutes du centre-ville, découvrez un véritable havre
          de paix. Notre terrasse ombragée vous accueille pour un moment de
          calme et de détente, loin de l'agitation, tout en restant au cœur
          de la ville. L'endroit idéal pour prendre le temps de profiter.
        </p>
      </header>

      {/* ── Galerie ─────────────────────────────────────────── */}
      <section className="terrasse-gallery" aria-label="Photos de la terrasse">
        {photos.map((p, i) => (
          <figure className="terrasse-gallery-item" key={i}>
            <img src={p.src} alt={p.alt} loading="lazy" />
          </figure>
        ))}
      </section>

      {/* ── CTA ─────────────────────────────────────────────── */}
      <div className="terrasse-cta-section">
        <p className="terrasse-cta-text">
          Profitez du soleil, réservez votre table en terrasse.
        </p>
        <a
          href="https://bookings.zenchef.com/results?rid=379037&pid=1001"
          target="_blank"
          rel="noopener noreferrer"
          className="terrasse-cta-btn"
        >
          Réserver une table
          <span className="terrasse-cta-arrow" />
        </a>
      </div>

    </main>
  );
}

export default Terrasse;
